module.exports = __webpack_public_path__ + "media/images/emblems/Wald-coat_of_arms-88cd99273e01ce8dce6c2162d8630ced.svg";